/* ================================================================
   Mystery Box 2.0 — Builder logic V1 basedodici
   Adattato da byob.js gerico V2.

   Differenze chiave:
   - 2 page flow: intro + builder (gender via URL param)
   - localStorage persistence + resume popup friendly
   - Inline size selection (no bottom sheet)
   - maxItems 20, tiers 10/15/20/25/30
   - Store basedodici-official + microservizio mystery.basedodici.com
   - Redirect a intro se gender param manca/invalid
   ================================================================ */

(function () {
  'use strict';

  // === Edge case: redirect se gender param missing/invalid ===
  const params = new URLSearchParams(window.location.search);
  const gender = params.get('gender');
  if (gender !== 'man' && gender !== 'woman') {
    window.location.replace('/pages/mystery-box-2-0');
    return;
  }

  const root = document.querySelector('[data-mystery-builder]');
  if (!root) return;

  // Flag al body — usato da CSS per riposizionare WhatsApp button su questa sola pagina
  document.body.classList.add('mystery-builder-active');

  // === Counter delle Mystery Box dello stesso gender attualmente nel carrello ===
  // Aggiornato da refreshCartBundlesCount() al boot + dopo CTA + su theme:cart:close.
  // Usato da renderFooter per condizionare visibilità "Modifica un'altra box" link.
  let cartBundlesCount = 0;
  async function refreshCartBundlesCount() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      cartBundlesCount = (cart.items || []).filter((it) => {
        if (!it.properties || !it.properties.Box) return false;
        const vt = (it.variant_title || '').toLowerCase();
        return (gender === 'man' && vt.includes('uomo')) || (gender === 'woman' && vt.includes('donna'));
      }).length;
    } catch { cartBundlesCount = 0; }
  }

  // === Secondary footer actions (creati dinamicamente, no template edit) ===
  // "+ Crea una nuova Mystery Box" → reset state (mantieni vecchia box nel cart) + UI fresca
  // "Modifica un'altra box" → richiama showResumePopup() per scegliere quale modificare
  let newBoxBtn = null;
  let modifyOtherLink = null;
  (function setupSecondaryActions() {
    const footer = root.querySelector('.mystery-sticky-footer');
    if (!footer) return;
    newBoxBtn = document.createElement('button');
    newBoxBtn.type = 'button';
    newBoxBtn.className = 'mystery-cta mystery-cta--secondary';
    newBoxBtn.setAttribute('data-mystery-new-box', '');
    newBoxBtn.hidden = true;
    newBoxBtn.innerHTML = '<span>+ Crea una nuova Mystery Box</span>';
    footer.appendChild(newBoxBtn);

    modifyOtherLink = document.createElement('button');
    modifyOtherLink.type = 'button';
    modifyOtherLink.className = 'mystery-cta-link';
    modifyOtherLink.setAttribute('data-mystery-modify-other', '');
    modifyOtherLink.hidden = true;
    modifyOtherLink.innerHTML = 'Modifica un’altra box →';
    footer.appendChild(modifyOtherLink);

    newBoxBtn.addEventListener('click', () => {
      // Mantieni cart inalterato (la vecchia box resta dentro). Reset solo state in-memory + localStorage.
      try { localStorage.removeItem(STORAGE_KEY); } catch {}
      state.items = [];
      state.boxId = null;
      state.isInCart = false;
      state.inCartWrapperVariantId = null;
      render();
      // Scroll up al primo card grid per UX "stai ricominciando"
      const gridFirst = root.querySelector('[data-gender-filter="' + gender + '"]');
      if (gridFirst) gridFirst.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    modifyOtherLink.addEventListener('click', () => {
      // Riapre il popup resume con la lista box presenti, per scelta modifica
      if (typeof showResumePopup === 'function') showResumePopup();
    });
  })();

  // === Loading overlay (popup spinner durante Componi / Aggiorna) ===
  // Setup una sola volta. Non blocca scroll permanente: chiuso su success o errore.
  // Stato cambia titolo da "Stiamo creando..." (nuova box) a "Stiamo aggiornando..." (modify).
  const loadingOverlay = (function setupLoadingOverlay() {
    const el = document.createElement('div');
    el.className = 'mystery-loading';
    el.setAttribute('hidden', '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = `
      <div class="mystery-loading__box">
        <div class="mystery-loading__spinner" aria-hidden="true"></div>
        <p class="mystery-loading__title" data-mystery-loading-title>STIAMO CREANDO LA TUA MYSTERY BOX</p>
        <p class="mystery-loading__subtitle">Un attimo di pazienza...</p>
      </div>
    `;
    document.body.appendChild(el);
    const titleEl = el.querySelector('[data-mystery-loading-title]');
    // Salva l'overflow body precedente per ripristinarlo correttamente in hide().
    // Lock scroll durante operazione: pattern già usato dal resume popup; serve a evitare
    // che scroll mentre /cart/add.js + getCart() sono pending triggeri listener scroll del
    // theme (cart drawer state inconsistency, fetch cancel, focus jumps).
    let prevOverflow = '';
    return {
      show(mode) {
        titleEl.textContent = mode === 'update'
          ? 'STIAMO AGGIORNANDO LA TUA MYSTERY BOX'
          : 'STIAMO CREANDO LA TUA MYSTERY BOX';
        prevOverflow = document.body.style.overflow || '';
        document.body.style.overflow = 'hidden';
        el.removeAttribute('hidden');
      },
      hide() {
        el.setAttribute('hidden', '');
        // Ripristina overflow body. Se nel frattempo il cart drawer del theme l'ha settato
        // a 'hidden' lui stesso (suo scroll lock proprio), il drawer mantiene la sua logica:
        // restoriamo solo al valore PRE-spinner, no override aggressivo.
        document.body.style.overflow = prevOverflow;
      },
    };
  })();

  // WhatsApp button: nascosto del tutto sulla pagina builder (mobile + desktop).
  // Lo sticky footer ora può avere fino a 3 elementi (CTA + secondario + link "Modifica un'altra
  // box") quando state.isInCart && cartBundlesCount >= 2: il vecchio shift bottom: 110px non basta.
  // Sulla pagina builder il flow è self-contained (componi → cart drawer), l'help WhatsApp è meno
  // rilevante rispetto ad altre pagine. App esterna Spike inject async → poll + observer per coprire.
  (function setupWhatsAppHide() {
    function findWhatsAppContainers() {
      const found = new Set();
      const seeds = [
        ...document.querySelectorAll('.spk-wsp-chat-btn, [class*="spk-wsp" i]'),
      ];
      seeds.forEach((el) => {
        let node = el;
        for (let i = 0; i < 8 && node && node !== document.body; i++) {
          const cs = getComputedStyle(node);
          if (cs.position === 'fixed') { found.add(node); break; }
          node = node.parentElement;
        }
        if (getComputedStyle(el).position === 'fixed') found.add(el);
      });
      return Array.from(found);
    }

    function hide() {
      findWhatsAppContainers().forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.dataset.mysteryWaHidden = '1';
      });
    }

    hide();
    setTimeout(hide, 500);
    setTimeout(hide, 1500);
    setTimeout(hide, 3500);

    const obs = new MutationObserver(() => hide());
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 10000);
  })();

  const dataEl = root.querySelector('[data-mystery-data]');
  if (!dataEl) return;
  const DATA = JSON.parse(dataEl.textContent);

  const STORAGE_KEY = 'mystery_box_state_v1_' + gender;
  const MICROSERVICE_URL = 'https://mystery.basedodici.com/api/bundle/create';
  const STORE_DOMAIN = 'basedodici-official.myshopify.com';

  const state = {
    items: [],
    boxId: null,
    isInCart: false,
    inCartWrapperVariantId: null,
  };

  // === Show right gender grid, hide other ===
  root.querySelectorAll('[data-gender-filter]').forEach((grid) => {
    grid.hidden = (grid.dataset.genderFilter !== gender);
  });
  const genderLabelEl = root.querySelector('[data-mystery-gender-label]');
  if (genderLabelEl) {
    genderLabelEl.textContent = gender === 'man' ? 'MAN' : 'WOMAN';
  }

  // === Filter DATA.products to current gender ===
  const allowedHandles = Array.from(
    root.querySelectorAll('[data-gender-filter="' + gender + '"] [data-mystery-card]')
  ).map((c) => c.dataset.productHandle);
  const productByHandle = (h) => DATA.products.find((p) => p.handle === h);

  // === localStorage (con TTL 1 ora) ===
  const STATE_TTL_MS = 60 * 60 * 1000; // 1 ora
  function saveState() {
    try {
      const wrapped = { ...state, _savedAt: Date.now() };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(wrapped));
    } catch (e) {}
  }
  function loadState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      // Scadenza: state vecchio > 1 ora → considerato stale, restituisci null
      if (parsed && parsed._savedAt && (Date.now() - parsed._savedAt) > STATE_TTL_MS) {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        return null;
      }
      return parsed;
    } catch (e) { return null; }
  }
  function clearState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // === helpers ===
  const fmtPrice = (n) => '€' + (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
  function activeTier() {
    const n = state.items.length;
    let tier = { items: 0, discount: 0 };
    for (const t of DATA.tiers) if (n >= t.items) tier = t;
    return tier;
  }
  function nextTier() {
    const n = state.items.length;
    for (const t of DATA.tiers) if (n < t.items) return t;
    return null;
  }
  const totalOriginal = () => state.items.reduce((s, i) => s + i.price, 0);
  const totalDiscounted = () => totalOriginal() * (1 - activeTier().discount / 100);
  const itemsByHandle = (h) => state.items.filter((i) => i.handle === h);
  function genBoxId() {
    return 'box_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  // === rendering ===
  function renderCardCounters() {
    root.querySelectorAll('[data-mystery-card]').forEach((card) => {
      const handle = card.dataset.productHandle;
      const qty = itemsByHandle(handle).length;
      const qtyEl = card.querySelector('[data-mystery-qty]');
      if (qtyEl) qtyEl.textContent = qty;
      card.classList.toggle('is-selected', qty > 0);

      // Per-size counter inline (formato "M·2")
      card.querySelectorAll('[data-mystery-size]').forEach((btn) => {
        const size = btn.dataset.size;
        const count = state.items.filter((i) => i.handle === handle && i.size === size).length;
        btn.dataset.count = String(count);
        btn.classList.toggle('is-active', count > 0);
      });

      // Decrement button: visible only if qty > 0
      const decBtn = card.querySelector('[data-mystery-decrement]');
      if (decBtn) decBtn.hidden = (qty === 0);
    });
  }

  function renderTierBar() {
    const n = state.items.length;
    const maxCheck = DATA.tiers[DATA.tiers.length - 1].items;
    const pct = Math.min(100, (n / maxCheck) * 100);
    const fillEl = root.querySelector('[data-mystery-tier-fill]');
    if (fillEl) fillEl.style.width = pct + '%';
    root.querySelectorAll('[data-checkpoint]').forEach((cp) => {
      cp.classList.toggle('is-active', n >= parseInt(cp.dataset.checkpoint, 10));
    });
  }

  function renderFooter() {
    const itemsCountEl = root.querySelector('[data-mystery-items-count]');
    const priceOrigEl = root.querySelector('[data-mystery-price-original]');
    const priceCurrEl = root.querySelector('[data-mystery-price-current]');
    const msgEl = root.querySelector('[data-mystery-tier-message]');
    const ctaEl = root.querySelector('[data-mystery-cta]');

    const n = state.items.length;
    if (itemsCountEl) itemsCountEl.textContent = '(' + n + '/' + DATA.maxItems + ')';
    const orig = totalOriginal();
    const curr = totalDiscounted();
    const tier = activeTier();
    if (priceOrigEl) priceOrigEl.textContent = tier.discount > 0 ? fmtPrice(orig) : '';
    if (priceCurrEl) priceCurrEl.textContent = fmtPrice(curr);

    const next = nextTier();
    if (msgEl) {
      if (n < DATA.minItems) {
        const left = DATA.minItems - n;
        msgEl.textContent = 'Aggiungi almeno ' + left + ' cap' + (left === 1 ? 'o' : 'i') + ' per attivare lo sconto';
        msgEl.classList.remove('is-success');
      } else if (next) {
        const left = next.items - n;
        msgEl.textContent = 'Sei a -' + tier.discount + '%. Aggiungi ' + left + ' cap' + (left === 1 ? 'o' : 'i') + ' per -' + next.discount + '% 🔥';
        msgEl.classList.remove('is-success');
      } else {
        msgEl.textContent = '✓ Sconto massimo attivo: -' + tier.discount + '%';
        msgEl.classList.add('is-success');
      }
    }

    if (ctaEl) {
      const ctaText = ctaEl.querySelector('.mystery-cta__text');
      if (ctaText) ctaText.textContent = state.isInCart ? 'Aggiorna la Mystery Box' : 'Componi la tua Mystery Box';
      ctaEl.disabled = n < DATA.minItems;
    }

    // Secondary actions: visibili condizionatamente in base allo state cart.
    // - "+ Crea una nuova" visibile quando isInCart=true (cliente ha già una box editing, vuole ricominciare)
    // - "Modifica un'altra box" visibile solo quando ci sono ≥2 box dello stesso gender nel cart
    if (newBoxBtn) newBoxBtn.hidden = !state.isInCart;
    if (modifyOtherLink) modifyOtherLink.hidden = (cartBundlesCount < 2);
  }

  function render() {
    renderCardCounters();
    renderTierBar();
    renderFooter();
    // NO saveState() qui — sovrascriverebbe lo state salvato durante init.
    // Chiamato esplicitamente dopo mutazioni: size click, decrement, CTA, popup choice.
  }

  // === card interactions ===
  root.querySelectorAll('[data-gender-filter="' + gender + '"] [data-mystery-card]').forEach((card) => {
    const handle = card.dataset.productHandle;
    const product = productByHandle(handle);
    if (!product) return;

    // No toggle: sizes always visible

    card.querySelectorAll('[data-mystery-size]').forEach((sizeBtn) => {
      sizeBtn.addEventListener('click', () => {
        if (state.items.length >= DATA.maxItems) return;
        if (sizeBtn.disabled) return;
        const variantId = sizeBtn.dataset.variantId;
        const size = sizeBtn.dataset.size;
        const price = parseFloat(sizeBtn.dataset.price);
        state.items.push({
          handle, productId: product.id, variantId, size, price, label: product.label,
        });
        render();
        saveState();
        sizeBtn.classList.add('is-pulse');
        setTimeout(() => sizeBtn.classList.remove('is-pulse'), 250);
      });
    });

    const decBtn = card.querySelector('[data-mystery-decrement]');
    if (decBtn) {
      decBtn.addEventListener('click', () => {
        const idx = state.items.map((i) => i.handle).lastIndexOf(handle);
        if (idx >= 0) { state.items.splice(idx, 1); render(); saveState(); }
      });
    }
  });

  // === CTA: microservizio + cart/add ===
  const cta = root.querySelector('[data-mystery-cta]');
  if (cta) {
    const ctaText = cta.querySelector('.mystery-cta__text');
    const ctaSpinner = cta.querySelector('.mystery-cta__spinner');

    cta.addEventListener('click', async () => {
      if (state.items.length < DATA.minItems) return;
      cta.disabled = true;
      ctaText.textContent = 'Componendo...';
      if (ctaSpinner) ctaSpinner.hidden = false;
      loadingOverlay.show(state.isInCart ? 'update' : 'create');

      // Step tracking per error diagnostics: se exception in catch, vediamo dove fallisce
      let currentStep = 'init';
      try {
        // Fetch cart per (a) cancellare vecchia box se modify (b) calcolare boxIndex
        currentStep = 'fetch_cart_initial';
        console.log('[Mystery] step:', currentStep);
        const cart = await (await fetch('/cart.js')).json();
        const cartItems = cart.items || [];

        let boxIndex = 1;
        if (state.isInCart && state.inCartWrapperVariantId) {
          // MODIFY: trova la vecchia box, riusa il suo boxIndex, cancellala
          const oldLineItem = cartItems.find((it) => String(it.variant_id) === String(state.inCartWrapperVariantId));
          if (oldLineItem) {
            const parsedBox = parseInt((oldLineItem.properties || {}).Box, 10);
            if (!isNaN(parsedBox) && parsedBox > 0) boxIndex = parsedBox;
            const updates = {};
            updates[oldLineItem.key] = 0;
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates }),
            });
          }
        } else {
          // NUOVA: calcola max(Box) tra i line items presenti + 1
          let maxIdx = 0;
          for (const it of cartItems) {
            const b = parseInt((it.properties || {}).Box, 10);
            if (!isNaN(b) && b > maxIdx) maxIdx = b;
          }
          boxIndex = maxIdx + 1;
        }

        // boxId SEMPRE nuovo per ogni click CTA: evita idempotency hit del microservizio
        // che riuserebbe il vecchio bundle. State.boxId è solo storia per logging.
        const boxId = genBoxId();
        const tier = activeTier();
        const apiBody = {
          store: STORE_DOMAIN,
          boxId,
          boxIndex,
          gender: gender === 'man' ? 'uomo' : 'donna', // microservizio usa italiano legacy
          tierDiscount: tier.discount,
          items: state.items.map((i) => ({
            variantId: String(i.variantId).startsWith('gid://') ? i.variantId : 'gid://shopify/ProductVariant/' + i.variantId,
            productHandle: i.handle,
            size: i.size,
            category: i.label,
            price: Math.round(i.price * 100),
          })),
        };

        currentStep = 'post_microservice';
        console.log('[Mystery] step:', currentStep);
        const apiResp = await fetch(MICROSERVICE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Idempotency-Key': boxId },
          body: JSON.stringify(apiBody),
        });
        if (!apiResp.ok) {
          const err = await apiResp.json().catch(() => ({}));
          throw new Error(err.error || 'Errore microservizio ' + apiResp.status);
        }
        const bundle = await apiResp.json();

        // /cart/add.js può ritornare 422 "Cannot find variant" intermittentemente: il
        // Storefront cart engine ha una cache/index distinta dall'Admin GraphQL master, e una
        // variant freshly created può non essere visibile a /cart/add.js per 1-5s anche dopo
        // sleep server-side. Retry exponential backoff (1s, 2s, 3s = max ~6s totali). Sicuro:
        // /cart/add.js è idempotente sull'add quando fallisce con 422 (non aggiunge nulla).
        currentStep = 'cart_add';
        console.log('[Mystery] step:', currentStep, '| variantId:', bundle.variantIdNumeric);
        async function cartAddOnce() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: bundle.variantIdNumeric, quantity: 1, properties: bundle.lineItemProperties }],
            }),
          });
        }
        const BACKOFFS_MS = [0, 1000, 2000, 3000]; // 4 tentativi totali: 0, +1s, +3s, +6s
        let cartResp = null;
        let lastErr = null;
        for (let attempt = 0; attempt < BACKOFFS_MS.length; attempt++) {
          if (BACKOFFS_MS[attempt] > 0) {
            currentStep = 'cart_add_retry_' + attempt;
            await new Promise((r) => setTimeout(r, BACKOFFS_MS[attempt]));
          }
          cartResp = await cartAddOnce();
          if (cartResp.ok) {
            if (attempt > 0) console.log('[Mystery] cart_add succeeded on attempt', attempt + 1);
            break;
          }
          lastErr = await cartResp.clone().json().catch(() => ({}));
          console.warn('[Mystery] cart_add attempt', attempt + 1, 'failed:', cartResp.status, lastErr);
        }
        if (!cartResp.ok) {
          throw new Error((lastErr?.description || 'Errore add.js ' + cartResp.status) + ' (after ' + BACKOFFS_MS.length + ' attempts)');
        }

        // Cart attribute "Mystery Box Bundle" → propaga a order.note_attributes al checkout.
        // Necessario per filter GLS warehouse: identifica gli ordini con Mystery Box per workflow
        // di picking speciale (item virtuale espanso in N children fisici). Fire-and-forget:
        // se fallisce non bloccare il flow (webhook orders/create server-side è la safety net).
        currentStep = 'cart_attribute';
        console.log('[Mystery] step:', currentStep);
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Mystery Box Bundle': 'Yes' } }),
          });
        } catch (attrErr) {
          console.warn('[Mystery] cart attribute set failed (non-fatal, webhook will cover):', attrErr);
        }

        state.boxId = boxId;
        state.isInCart = true;
        state.inCartWrapperVariantId = bundle.variantIdNumeric;
        saveState();

        // Apri il cart drawer del theme (consistency col resto del sito).
        // window.cart.getCart() refetcha la section api-cart-items, ribuilda i line items
        // e dispatcha theme:cart:added → build() apre auto openCartDrawer().
        // Fallback hard-redirect se il theme non espone l'istanza.
        if (window.cart && typeof window.cart.getCart === 'function') {
          ctaText.textContent = state.isInCart ? 'Aggiorna la Mystery Box' : 'Componi la tua Mystery Box';
          if (ctaSpinner) ctaSpinner.hidden = true;
          cta.disabled = false;

          // Spinner overlay close: ascolto ENTRAMBI gli eventi del theme cart per robustness.
          // theme:cart:added scatta sempre dopo getCart() ricezione section. theme:cart:open scatta
          // quando il drawer si apre visualmente. Usare solo theme:cart:open era fragile (se drawer
          // era già aperto da altra azione concorrente, evento non scatta → spinner non si chiude).
          const closeOverlay = () => {
            loadingOverlay.hide();
            document.removeEventListener('theme:cart:added', closeOverlay);
            document.removeEventListener('theme:cart:open', closeOverlay);
          };
          document.addEventListener('theme:cart:added', closeOverlay, { once: true });
          document.addEventListener('theme:cart:open', closeOverlay, { once: true });
          // Failsafe: hide a +4s comunque, evita spinner stuck se il theme non emette eventi
          setTimeout(closeOverlay, 4000);

          window.cart.getCart();

          // Conditional belt-and-suspenders re-render contro race section render Liquid:
          // SOLO se a +1500ms vediamo un line item Mystery con final_price=0 (= bug presente),
          // forziamo un secondo getCart per re-fetchare la section a propagazione completata.
          // Se tutto era già OK al primo colpo → niente flicker visibile.
          setTimeout(async () => {
            try {
              const cart = await (await fetch('/cart.js')).json();
              const hasBrokenMystery = (cart.items || []).some((it) => it.properties && it.properties.Box && it.final_price === 0);
              if (hasBrokenMystery && window.cart && typeof window.cart.getCart === 'function') {
                console.log('[Mystery] re-render: detected line_item.final_price=0, refetching cart section');
                window.cart.getCart();
              }
              // Aggiorna count box nel cart (può essere cambiato) e UI footer
              await refreshCartBundlesCount();
              render();
            } catch (e) {
              console.warn('[Mystery] conditional re-render check failed:', e);
            }
          }, 1500);
        } else {
          loadingOverlay.hide();
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('[Mystery] CTA error at step:', currentStep, '| error:', err, '| state:', { isInCart: state.isInCart, items: state.items.length });
        loadingOverlay.hide();
        ctaText.textContent = 'Errore — riprova';
        if (ctaSpinner) ctaSpinner.hidden = true;
        setTimeout(() => {
          ctaText.textContent = state.isInCart ? 'Aggiorna la Mystery Box' : 'Componi la tua Mystery Box';
          cta.disabled = state.items.length < DATA.minItems;
        }, 2000);
      }
    });
  }

  // === resume popup (multi-box logic) ===
  function isCurrentGenderBox(lineItem) {
    const vt = (lineItem.variant_title || '').toLowerCase();
    return (gender === 'man' && vt.includes('uomo')) || (gender === 'woman' && vt.includes('donna'));
  }

  // Parse "1× Mystery T-Shirt Man (M), 1× Mystery Hoodie Man (L)" → array items
  function parseItemsFromLineItem(lineItem) {
    const itemsStr = lineItem.properties && lineItem.properties.Items;
    if (!itemsStr) return [];
    const items = [];
    const re = /(\d+)×\s+([^()]+?)\s+\(([^)]+)\)/g;
    let m;
    while ((m = re.exec(itemsStr)) !== null) {
      const qty = parseInt(m[1], 10);
      const label = m[2].trim();
      const size = m[3].trim();
      const product = DATA.products.find((p) => p.label === label);
      if (!product) continue;
      const variant = product.variants.find((v) => v.title === size);
      if (!variant) continue;
      for (let i = 0; i < qty; i++) {
        items.push({
          handle: product.handle, productId: product.id, variantId: variant.id,
          size, price: variant.price, label: product.label,
        });
      }
    }
    return items;
  }

  async function showResumePopup() {
    let saved = loadState();
    let savedHasItems = saved && saved.items && saved.items.length > 0;

    // Fetch cart per scoprire bundle del gender corrente
    let cartBundles = [];
    try {
      const cart = await (await fetch('/cart.js')).json();
      cartBundles = (cart.items || [])
        .filter((it) => it.properties && it.properties.Box)
        .filter(isCurrentGenderBox)
        .map((it) => ({
          lineItemKey: it.key,
          variantId: it.variant_id,
          boxIndex: parseInt(it.properties.Box, 10) || 1,
          rawLineItem: it,
        }))
        .sort((a, b) => a.boxIndex - b.boxIndex);
    } catch (e) { /* fallback empty */ }

    // Saved state stale: era in cart ma non più (utente ha svuotato manualmente)
    // → cancel esplicito → reset totale, saved azzerato anche localmente
    if (savedHasItems && saved.isInCart && saved.inCartWrapperVariantId) {
      const stillInCart = cartBundles.some((b) => String(b.variantId) === String(saved.inCartWrapperVariantId));
      if (!stillInCart) {
        clearState();
        state.items = []; state.boxId = null; state.isInCart = false; state.inCartWrapperVariantId = null;
        // ANCHE reset variabili locali: altrimenti inProgress sotto rileverebbe saved.items > 0
        saved = null;
        savedHasItems = false;
      }
    }

    // Detect "duplicate state": gli items salvati matchano ESATTAMENTE quelli di una box
    // già nel cart (stesso multiset handle+size). È residue di un flow precedente già completato
    // (es: Componi success → state.items resta popolato → reload → popup duplicato confonde).
    // In tal caso silent clear dello state, NO popup "Continua box in corso".
    function itemsSignature(arr) {
      return arr.map((i) => i.handle + '::' + i.size).sort().join('|');
    }
    if (savedHasItems && cartBundles.length > 0) {
      const stateSig = itemsSignature(saved.items);
      const matchingBox = cartBundles.find((b) => itemsSignature(parseItemsFromLineItem(b.rawLineItem)) === stateSig);
      if (matchingBox) {
        // Sync: state si allinea alla box matching (così "Aggiorna" funziona se l'utente sceglie quella)
        clearState();
        state.items = saved.items.slice();
        state.boxId = saved.boxId || null;
        state.isInCart = true;
        state.inCartWrapperVariantId = matchingBox.variantId;
        saveState();
        saved = loadState();
        // saved.items è ancora popolato ma isInCart=true e variant matching → sotto NON sarà inProgress
      }
    }

    // Determina se c'è una "box in corso" separata (items > 0 e non corrispondente a cart variant)
    const inProgress = savedHasItems
      && (!saved.isInCart
          || !cartBundles.some((b) => String(b.variantId) === String(saved.inCartWrapperVariantId)));

    if (cartBundles.length === 0 && !inProgress) return false;

    // Build popup
    const popup = document.createElement('div');
    popup.className = 'mystery-resume-popup';
    const genderLabel = gender === 'man' ? 'MAN' : 'WOMAN';

    // Header + eyebrow
    let eyebrow, title;
    if (cartBundles.length > 1) {
      eyebrow = '🛒 ' + cartBundles.length + ' Mystery Box nel carrello';
      title = 'Hai ' + cartBundles.length + ' Mystery Box ' + genderLabel + ' nel carrello';
    } else if (cartBundles.length === 1) {
      eyebrow = '🛒 Mystery Box nel carrello';
      title = 'Hai una Mystery Box ' + genderLabel + ' nel carrello';
    } else {
      eyebrow = '👋 Mystery Box in corso';
      title = 'Ehi, hai lasciato una Mystery Box a metà';
    }

    // Build action buttons
    const buttons = [];
    cartBundles.forEach((b) => {
      const itemsCount = (b.rawLineItem.properties.Items || '').split(',').reduce((s, x) => {
        const m = x.match(/(\d+)×/);
        return s + (m ? parseInt(m[1], 10) : 0);
      }, 0);
      const priceFmt = (b.rawLineItem.price / 100).toFixed(2).replace('.', ',');
      buttons.push(
        '<button type="button" class="mystery-resume-popup__btn mystery-resume-popup__btn--primary" data-resume-modify="' + b.variantId + '">'
        + 'Modifica Box ' + b.boxIndex + (itemsCount ? ' &mdash; ' + itemsCount + ' cap' + (itemsCount === 1 ? 'o' : 'i') : '')
        + ' &mdash; €' + priceFmt
        + '</button>'
      );
    });
    if (inProgress) {
      const n = saved.items.length;
      buttons.push(
        '<button type="button" class="mystery-resume-popup__btn mystery-resume-popup__btn--primary" data-resume-continue-progress>'
        + 'Continua box in corso &mdash; ' + n + ' cap' + (n === 1 ? 'o' : 'i')
        + '</button>'
      );
    }
    buttons.push('<button type="button" class="mystery-resume-popup__btn mystery-resume-popup__btn--secondary" data-resume-new>Crea una nuova</button>');

    popup.innerHTML =
      '<div class="mystery-resume-popup__backdrop" data-resume-close></div>' +
      '<div class="mystery-resume-popup__panel">' +
        '<span class="mystery-resume-popup__eyebrow">' + eyebrow + '</span>' +
        '<h3 class="mystery-resume-popup__title">' + title + '</h3>' +
        '<p class="mystery-resume-popup__text">Cosa vuoi fare?</p>' +
        '<div class="mystery-resume-popup__actions">' + buttons.join('') + '</div>' +
      '</div>';
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';

    function close() { popup.remove(); document.body.style.overflow = ''; }

    // Wire: Modifica Box N (carica items dal line item del cart)
    popup.querySelectorAll('[data-resume-modify]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const variantId = btn.dataset.resumeModify;
        const box = cartBundles.find((b) => String(b.variantId) === String(variantId));
        if (!box) { close(); return; }
        const items = parseItemsFromLineItem(box.rawLineItem);
        state.items = items;
        state.boxId = null;            // forza nuovo boxId al click CTA
        state.isInCart = true;
        state.inCartWrapperVariantId = box.variantId;
        render();
        saveState();
        close();
      });
    });

    // Wire: Continua box in corso (state.items già popolato da saved)
    const continueBtn = popup.querySelector('[data-resume-continue-progress]');
    if (continueBtn) {
      continueBtn.addEventListener('click', () => {
        if (savedHasItems) {
          state.items = saved.items.slice();
          state.boxId = saved.boxId || null;
          state.isInCart = saved.isInCart === true && cartBundles.some((b) => String(b.variantId) === String(saved.inCartWrapperVariantId));
          state.inCartWrapperVariantId = state.isInCart ? saved.inCartWrapperVariantId : null;
        }
        render();
        saveState();
        close();
      });
    }

    // Wire: Crea nuova
    popup.querySelector('[data-resume-new]').addEventListener('click', () => {
      clearState();
      state.items = []; state.boxId = null; state.isInCart = false; state.inCartWrapperVariantId = null;
      render();
      close();
    });
    popup.querySelector('[data-resume-close]').addEventListener('click', close);
    return true;
  }

  // === Listener cart drawer close (X o checkout) ===
  // Quando l'utente chiude il drawer e torna alla pagina builder via AJAX (no page reload),
  // dobbiamo riallineare lo state: il cart potrebbe avere variants diverse rispetto a prima,
  // il count bundles cambiato, il flag isInCart non più valido (es. utente ha rimosso la box).
  // Trigger condizionale: se la wrapper variant di state non c'è più nel cart → reset (= cancel
  // esplicito, fresh start, vedi feedback-cart-manual-empty-equals-fresh-start).
  document.addEventListener('theme:cart:close', async () => {
    try {
      const cart = await (await fetch('/cart.js')).json();
      const items = cart.items || [];
      // Refresh count box stesso gender
      cartBundlesCount = items.filter((it) => {
        if (!it.properties || !it.properties.Box) return false;
        const vt = (it.variant_title || '').toLowerCase();
        return (gender === 'man' && vt.includes('uomo')) || (gender === 'woman' && vt.includes('donna'));
      }).length;
      // Se la wrapper variant del state non è più nel cart → cancel esplicito → reset
      if (state.isInCart && state.inCartWrapperVariantId) {
        const stillPresent = items.some((it) => String(it.variant_id) === String(state.inCartWrapperVariantId));
        if (!stillPresent) {
          try { localStorage.removeItem(STORAGE_KEY); } catch {}
          state.items = []; state.boxId = null; state.isInCart = false; state.inCartWrapperVariantId = null;
        }
      }
      render();
    } catch (e) {
      console.warn('[Mystery] theme:cart:close refresh failed:', e);
    }
  });

  // === init ===
  // IMPORTANT: showResumePopup() PRIMA di render(), così legge lo state salvato.
  // render() ora non chiama saveState(), quindi non sovrascrive.
  refreshCartBundlesCount().then(() => {
    showResumePopup();
    render();
  });
})();
